import { Spin, useAppContext } from 'platform-components';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { actions as lessonActions } from 'common.components/lesson';
import LessonView from 'common.components/lesson-view.index/lesson-view';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';

interface ViewDeps {
    clessonId: number;
    courseId: number;
}

/**
 * Страница, на которой мы показываем учителю из МЭШ модалку выданного урока и ничего более
 */
export const ExternalShowAssignedLessonPage = () => {
    const { data: viewDeps } = useAppContext();
    const { clessonId, courseId } = viewDeps as any as ViewDeps;

    const dispatch = useDispatch();

    const [lessonLoaded, setLessonLoaded] = useState(false);

    // Эта зависимость нужна для модалки
    useEffect(() => {
        dispatch(
            lessonActions.getClessonWithResultsRequest({
                courseId,
                clessonId,
                onSuccess: () => {
                    dispatch(lessonViewActions.toggleModal(true));
                    setLessonLoaded(true);
                },
            })
        );
    }, [clessonId, courseId, dispatch]);

    return (
        <div className="external-show-assigned-lesson">
            {lessonLoaded ? (
                <LessonView
                    hideBanners={true}
                    hideCloseButton={true}
                    hideFooter={true}
                    isCopyingEnabled={false}
                    isPutOnBoardEnabled={false}
                />
            ) : (
                <Spin center={true} />
            )}
        </div>
    );
};
